import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SubMenuFields from './SubMenuFields'

export const SubMenuCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <SubMenuFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default SubMenuCreate
